var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-collapse',{attrs:{"visible":"","id":"sidebar-1","bg-variant":"dark"}},[_c('ToolTabs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }